import { render, staticRenderFns } from "./ArrowIcon.vue?vue&type=template&id=5b4372b2&scoped=true&"
import script from "./ArrowIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4372b2",
  null
  
)

export default component.exports